<template>
    <section class="page notification">
        <div class="notification-center">
            
        <h1>Уведомления</h1>
        <div class="notification-container" v-if="notifications && notifications.length > 0">
            <div class="notification-item" v-for="notification in notifications" :key="notification.id">
                <router-link :tag="'div'" :to="{name: 'pin', params: {id: notification.pin_id}}" class="notification-body" v-if="notification.type === 'pin_comment'">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> оставил комментарий к вашей записи</p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </router-link>
                <router-link :tag="'div'" :to="{name: 'pin', params: {id: notification.pin_id}}" class="notification-body" v-if="notification.type === 'pin_like'">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> поставил лайк вашей записи</p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </router-link>
                <router-link :tag="'div'" :to="{name: 'offers'}" class="notification-body" v-if="notification.type === 'new_friendship'">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> предлагает вам дружбу</p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </router-link>
                <router-link :tag="'div'"  :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-body" v-if="notification.type === 'accept_friendship'">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> принял(а) вашу заявку в друзья</p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </router-link>
                <div class="notification-body" v-if="notification.type === 'join_event' && notification.event">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> присоединился(ась) к вашему ивенту  <router-link :tag="'span'" :to="{name: 'event', params: {hash: notification.event.id + '&' + notification.event.hash}}">«‎‎{{ notification.event.title }}»</router-link></p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </div>
                <div class="notification-body" v-if="notification.type === 'leave_event' && notification.event">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> покинул(а) ивент  <router-link :tag="'span'" :to="{name: 'event', params: {hash: notification.event.id + '&' + notification.event.hash}}">«‎‎{{ notification.event.title }}»</router-link></p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </div>
                <div class="notification-body" v-if="notification.type === 'delete_from_chat'">
                    <router-link :tag="'div'" :to="{name: 'user', params: {id: notification.from_user.id}}" class="notification-item__cover" :style="{backgroundImage: 'url(' + getAvatar(notification.from_user) + ')'}"></router-link>
                    <div class="notification-wrap">
                        <div class="notification-item__message">
                            <p><router-link :to="{name: 'user', params: {id: notification.from_user.id}}">{{ getUserName(notification) }}</router-link> удалил(а) вас из чата  <router-link :tag="'span'" :to="{name: 'chat', params: {hash: notification.chat.id + '&' + notification.chat.hash}}">«‎‎{{ notification.chat.caption }}»</router-link></p>
                        </div>
                        <div class="notification-item__date">{{ getTime(notification) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="timeline-nothing" v-else>
          У вас нет новых уведомлений
        </div>
        </div>
    </section>
</template>

<script>

export default {
  name: 'Notifications',
  data: () => {
      return {
          notifications: null
      }
  },
  computed: {
    getChats () {
      return this.$store.getters.getChats
    },
    getUser() {
      let user = this.$store.getters.getAuthUser;
      return user ? user.id : null
    }
  },
  watch: {
      getUser () {
         this.loadData()
      }
  },
  methods: {
      async loadData() {
        this.notifications = this.getUser ? await this.$store.dispatch('fetchNotifications', {user: this.getUser}) : null;
      },
      getUserName (notification) {
          return notification.from_user.firstname + ' ' + notification.from_user.lastname;
      },
      getTime(notification) {
          return this.$moment(notification.date).locale('ru').calendar().toLowerCase()
      },
      getAvatar(user) {
        return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
    },
  },
  async created() {
    await this.loadData();
    this.$store.dispatch('clearNotifications')
  }
}

</script>
